<template>
  <main class="files">
    <h3 class="files__title">files</h3>
    <loading-icon v-if="loading"></loading-icon>

    <transition name="fade">
      <p v-if="successMessage" class="files__message files__success">{{successMessage}}</p>
    </transition>

    <file-attachments
        v-show="!loading"
        :files="files"
        :loading="loading"
        :pagination="pagination"
        @loadFiles="loadFiles"
        @setMessage="setMessage">
    </file-attachments>

    <transition name="fade">
      <p v-if="errorMessage" class="files__message files__error">{{errorMessage}}</p>
    </transition>

    <div class="files__divider divider"></div>

    <file-upload
        @loadFiles="loadFiles"
        @setMessage="setMessage">
    </file-upload>
  </main>
</template>

<script>
  import AxiosMixin from '../mixins/AxiosMixin'
  import FileAttachments from './FileAttachments'
  import FileUpload from './FileUpload'
  import LoadingIcon from '../Shared/LoadingIcon'
  import { mapGetters } from 'vuex'

  export default {
    props: {
      currentAdvertiser: Object,
    },

    name: 'Files',

    mixins: [AxiosMixin],

    components: {
      FileAttachments,
      FileUpload,
      LoadingIcon,
    },

    data() {
      return {
        errorMessage: null,
        errorTextBase: 'there was an issue loading the files',
        files: [],
        loading: false,
        pagination: null,
        successMessage: null,
      }
    },

    computed: {
      ...mapGetters(['brandId'])
    },

    methods: {
      loadFiles(page = null) {
        this.loading = true
        let url = `/attachments/?brand_id=${this.brandId}`
        url = page ? `${url}&page=${page}` : url
        this.axiosMethod({url, onSuccess: this.onLoadSuccess, onError: this.onLoadError})
      },

      onLoadError(error) {
        this.errorMessage = `${this.errorTextBase}: ${error}`
        if (this.loading) { this.loading = false }
      },

      onLoadSuccess(data) {
        const attachments = data?.user_attachments,
          pagination = data?.pagination,
          hasPagination = pagination?.total_pages > 1
        if (attachments) { this.files = [...attachments] }
        this.pagination = hasPagination ? {...pagination} : null
        this.errorMessage = attachments ? null : this.errorTextBase
        if (this.loading) { this.loading = false }
      },

      setMessage(message, messageType) {
        this[`${messageType}Message`] = message

        const isSuccess = messageType === 'success'
        isSuccess && setTimeout(() => this.successMessage = null, 4000)
      }
    },

    created() {
      this.loadFiles()
    },
  }
</script>

<style lang="sass">
  @import '../../assets/sass/colors'

  .files
    margin: 0 auto
    max-width: 90%
    padding: 2rem 0

    &__title,
    &__message
      text-align: center

    &__message
      font-weight: bold
      padding: 0.5em

    &__error
      color: $negative-hover

    &__success
      color: $success-green

    &__divider.divider
      width: 95%

    .fade-enter-active,
    .fade-leave-active
      transition: opacity .5s

    .fade-enter,
    .fade-leave-to
      opacity: 0

</style>